import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';
import GeneralEmptyStateListView from '@commons/GeneralEmptyStateListView';

import { Actions } from './styledComponents';

const EMPTY_CATALOG_ILLUSTRATION = '/images/grouped-order-empty-state.svg';

/**
 * Empty state of a client with no catalog. Both entry points are laid out side by side rather than
 * behind the list `Actions` dropdown, which does not exist yet at that point. Without the
 * `external-client:edit` right there is nothing to offer, so only the message is rendered.
 */
const CatalogEmptyState = (props) => {
  const { canEdit, onAdd, onClone } = props;

  const renderActions = () => (
    <Actions>
      <Button
        color={'inpulse-outline'}
        handleClick={onClone}
        icon={'/images/inpulse/clone-black.svg'}
        label={i18next.t('EXTERNAL_CLIENTS.CATALOG.CLONE_ACTION')}
      />
      <Button
        color={'inpulse-default'}
        handleClick={onAdd}
        icon={'/images/inpulse/add-white-small.svg'}
        label={i18next.t('GENERAL.ADD')}
      />
    </Actions>
  );

  return (
    <GeneralEmptyStateListView
      icon={EMPTY_CATALOG_ILLUSTRATION}
      renderAction={canEdit ? renderActions : undefined}
      subtitle={i18next.t('EXTERNAL_CLIENTS.CATALOG.EMPTY_STATE_SUBTITLE')}
      title={i18next.t('EXTERNAL_CLIENTS.CATALOG.EMPTY_STATE_TITLE')}
    />
  );
};

CatalogEmptyState.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
};

export default CatalogEmptyState;
